import { Box } from "@mui/material";
import { Text } from "@asayinc/component-library";

interface IMaterialsViewProps {
  id: string;
  url: string;
}

export const MaterialsView = ({
  id,
  url,
}: IMaterialsViewProps): JSX.Element => {
  if (!url) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text>Select materials from the list to view.</Text>
      </Box>
    );
  }
  return (
    <Box
      component="iframe"
      key={id}
      src={url || "#"}
      sx={{ width: "100%", height: "100%" }}
    />
  );
};
